/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $DoctorSpecialty = {
  properties: {
    specialty: {
      type: 'string',
      isRequired: true,
    },
    rqe: {
      type: 'string',
      isRequired: true,
    },
    type: {
      type: 'DoctorSpecialtyType',
      isRequired: true,
    },
  },
} as const;
